var _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 88,
    viewBox: "0 0 293 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 49.647,
    cy: 96.2787,
    rx: 136.647,
    ry: 95.6146,
    fill: "#4C862E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 155.647,
    cy: 122.47,
    rx: 136.647,
    ry: 95.6146,
    fill: "#4C862E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerDesign);
export default __webpack_public_path__ + "static/media/lowerDesign.9fc5c18fa65f1bad4db69003f0ed28e1.svg";
export { ForwardRef as ReactComponent };